import { Button, Form, Input, Row, Select } from "antd";
import { Col20, Col4 } from "src/components/Columns";
import { SearchPatientsFilters } from "src/common/models/patient";
import { getInputRequiredRule } from "src/common/util";
import { useState } from "react";
import { SearchOutlined } from '@ant-design/icons';
import { SystemDescriptions } from "src/common/descriptions/descriptions";

export enum PatientSearchType {
    NAME = "name",
    SURNAME = "surname",
    IDENTIFICATION = "identification",
    PHONE = "phone",
    ID = "id",
    EMAIL = "email",
}

interface Props {
    onFinish: (searchPatientsFilters: SearchPatientsFilters) => void
    loading?: boolean
}

export const InputSearchForm = (props: Props) => {

    const [searchType, setSearchType] = useState<PatientSearchType>(PatientSearchType.NAME);

    const [form] = Form.useForm();

    const descriptions = SystemDescriptions.COMPONENTS.PATIENT_SEARCH

    const handleTypeChange = (value: PatientSearchType) => {
        setSearchType(value);
        form.setFieldsValue({ searchValue: '' });
    }

    const selectBefore = (
        <Select
            style={{ width: 120 }}
            defaultValue={PatientSearchType.NAME}
            onChange={handleTypeChange}
            options={[
                {
                    label: descriptions.SEARCH_FORM.SEARCH_TYPE.NAME,
                    value: PatientSearchType.NAME,
                },
                {
                    label: descriptions.SEARCH_FORM.SEARCH_TYPE.SURNAME,
                    value: PatientSearchType.SURNAME,
                },
                {
                    label: descriptions.SEARCH_FORM.SEARCH_TYPE.PHONE,
                    value: PatientSearchType.PHONE,
                },
                {
                    label: descriptions.SEARCH_FORM.SEARCH_TYPE.IDENTIFICATION,
                    value: PatientSearchType.IDENTIFICATION,
                },
                {
                    label: descriptions.SEARCH_FORM.SEARCH_TYPE.ID,
                    value: PatientSearchType.ID,
                },
            ]}
        />
    );

    const onFinish = (formValues: any) => {
        if (!formValues.searchValue) {
            return;
        }

        const filters: SearchPatientsFilters = {
            [searchType]: formValues.searchValue,
        }

        props.onFinish(filters)
    }

    const renderForm = () => {
        return <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col20>
                    <Form.Item
                        name={"searchValue"}
                        rules={[
                            getInputRequiredRule(descriptions.SEARCH_FORM.SEARCH_VALUE.LABEL)
                        ]}
                    >
                        <Input
                            addonBefore={selectBefore}
                            placeholder={descriptions.SEARCH_FORM.SEARCH_VALUE.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col20>
                <Col4>
                    <Form.Item
                        label={""}
                    >
                        <Button
                            style={{ width: '100%' }}
                            type="primary"
                            loading={props.loading}
                            disabled={props.loading}
                            htmlType="submit"
                            icon={<SearchOutlined />}
                        >
                            {descriptions.SEARCH_FORM.SEARCH_BUTTON}
                        </Button>
                    </Form.Item>
                </Col4>
            </Row>
        </Form>
    }

    return (
        renderForm()
    )
}
